module.exports = __webpack_public_path__ + "dimer/static/img/DrPenny.c889d27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DrPenny.jpg
// module id = oU5Z
// module chunks = 0